import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@repo/ui/components/theme-provider';
import { LoggerProvider, LogLevel } from '@repo/ui/lib/logger/index';
import { AuthProvider } from '@repo/ui/lib/providers/index';
import { QueryProvider } from '../../components/providers';
import { GoogleMapsGlobalProvider } from '@repo/ui/features/inventaires/map-view/providers/google-maps-global-provider';
import { Toaster } from 'sonner';
import { useResetLocalStorageOnVersionChange } from '../hooks/use-reset-local-storage-on-version-change';

export default function RootLayout() {
  // #region agent log

  // #endregion
  useResetLocalStorageOnVersionChange();
  const apiKey = (import.meta.env?.VITE_GOOGLE_MAPS_API_KEY as string) || '';

  return (
    <ThemeProvider defaultTheme="system">
      <LoggerProvider options={{ level: LogLevel.DEBUG }}>

        {/* #endregion */}
        <QueryProvider>
          <AuthProvider>
              <GoogleMapsGlobalProvider apiKey={apiKey} libraries={['places', 'geometry', 'marker']}>
              <Outlet />
              <Toaster
                position="top-center"
                richColors
                closeButton
                toastOptions={{
                  duration: 3000,
                }}
              />
            </GoogleMapsGlobalProvider>
          </AuthProvider>
        </QueryProvider>
      </LoggerProvider>
    </ThemeProvider>
  );
}

